<div class="rewards-v1">
  <!-- Header Section -->
  <div class="rewards-header">
    <div class="header-content">
      <div class="title-section">
        <h1 class="page-title">Rewards</h1>
        <p class="page-subtitle">Track your success and rewards.</p>
      </div>
      <div class="lifetime-rewards-card">
        <div class="rewards-amount">
          <div class="trophy-icon">
            <img src="/assets/images/rewards/trophy.png" alt="Trophy" class="trophy-image">
          </div>
          <span class="amount">{{ lifetimeRewards }}</span>
        </div>
        <span class="lifetime-label">Lifetime rewards</span>
      </div>
    </div>
  </div>

  <!-- Reward Cards Section -->
  <div class="reward-cards">
    <div class="reward-card single-wash-card">
      <div class="card-content">
        <div class="card-header">
          <h3 class="card-title">{{ singleWashProgress.reward }}</h3>
        </div>
        <div class="progress-section">
          <div class="progress-bar">
            <div class="progress-track">
              <div class="progress-fill" [style.width.%]="(singleWashProgress.current / singleWashProgress.total) * 100"></div>
            </div>
            <div class="progress-text">
              <span class="current">{{ singleWashProgress.current }}</span>
              <span class="separator">/</span>
              <span class="total">{{ singleWashProgress.total }}</span>
            </div>
          </div>
        </div>
        <div class="card-footer">
          <div class="trophy-badge">
            <img src="/assets/images/rewards/white-trophy.svg" alt="Trophy">
            <span class="won-today">{{ singleWashProgress.wonToday }}</span>
          </div>
        </div>
      </div>
      <div class="card-image">
        <img src="/assets/images/rewards/single-wash-illustration.svg" alt="Single Wash Reward" class="illustration">
      </div>
    </div>

    <div class="reward-card membership-card">
      <div class="card-content">
        <div class="card-header">
          <h3 class="card-title">{{ membershipProgress.reward }}</h3>
          <p class="card-description">{{ membershipProgress.description }}</p>
        </div>
        <div class="card-footer">
          <div class="trophy-badge">
            <img src="/assets/images/rewards/white-trophy.svg" alt="Trophy">
            <span class="won-today">{{ membershipProgress.wonToday }}</span>
          </div>
        </div>
      </div>
      <div class="card-image">
        <img src="/assets/images/rewards/membership-illustration.svg" alt="Membership Reward" class="illustration">
      </div>
    </div>
  </div>

  <!-- Rewards History Section -->
  <div class="rewards-history">
    <div class="history-header">
      <h2 class="history-title">Rewards History</h2>
      <div class="period-selector">
        <span class="period-label">Period</span>
        <div class="period-dropdown-wrapper">
          <button
            class="dropdown-button"
            (click)="toggleDateRangePicker(); $event.stopPropagation()">
            <span>{{ selectedPeriod }}</span>
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"
                 [class.rotated]="isDateRangePickerOpen">
              <path d="M5.28 7.38L10 12.1L14.72 7.38" stroke="#15172E" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>

          <app-date-range-picker
            [isOpen]="isDateRangePickerOpen"
            [selectedPeriod]="selectedPeriod"
            [customDateRange]="customDateRange"
            [periodOptions]="periodOptions"
            (periodChange)="onDateRangePeriodChange($event)"
            (customDateRangeChange)="onCustomDateRangeChange($event)"
            (close)="closeDateRangePicker()"
            (apply)="onDateRangeApply($event)">
          </app-date-range-picker>
        </div>
      </div>
    </div>

    <div *ngIf="isLoading" class="loading-container">
      <div class="loading-spinner"></div>
      <p class="loading-text">Loading rewards data...</p>
    </div>

    <div *ngIf="!isLoading && rewardsHistory.length === 0" class="empty-state-container">
      <app-empty-result
        image="/assets/images/empty_screen.png"
        title="No rewards to display!"
        description="No rewards to show for the selected period."
        [showAction]="false">
      </app-empty-result>
    </div>

    <div *ngIf="!isLoading && rewardsHistory.length > 0" class="rewards-table-container">
      <table class="rewards-table">
        <thead>
          <tr>
            <th>Date</th>
            <th>Membership Threshold Reward</th>
            <th>Membership Reward</th>
            <th>Total Rewards</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of rewardsHistory; trackBy: trackByIndex">
            <td>{{ formatDate(item.date) }}</td>
            <td data-label="Membership Threshold Reward">{{ item.membership_threshold_points }}</td>
            <td data-label="Membership Reward">{{ item.membershipReward }}</td>
            <td data-label="Total Rewards">{{ item.totalRewards }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <app-pagination-bar
      *ngIf="!isLoading && rewardsHistory.length > 0"
      [paginationData]="paginationData"
      [itemsPerPageOptions]="itemsPerPageOptions"
      (pageChange)="onPageChange($event)"
      (itemsPerPageChange)="onItemsPerPageChange($event)">
    </app-pagination-bar>
  </div>
</div>
